import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { CustomModal, SpinnerLoader } from "@services/ui-components";

interface ConfirmUnpublishMenuModalProps {
    show: boolean;
    onClose: () => void;
    onConfirm: () => void;
    menuName?: string;
    loading?: boolean;
}

const ConfirmUnpublishMenuModal: React.FC<ConfirmUnpublishMenuModalProps> = ({
    show,
    onClose,
    onConfirm,
    menuName,
    loading,
}) => {
    const { t } = useTranslation();

    return (
        <CustomModal
            show={show}
            handleClose={onClose}
            title={
                <Container>
                    <Row>
                        <h5 className="m-0 p-0 fw-normal">{t("Unpublish the menu?")}</h5>
                    </Row>
                </Container>
            }
            body={
                <Container>
                    <Row>
                        <Col>
                            <span className="fs-16 text-dark">
                                {t(
                                    "The ({{menuName}}) menu will no longer be visible to customers. You can publish a different menu for this type at any time.",
                                    {
                                        menuName,
                                    }
                                )}
                            </span>
                        </Col>
                    </Row>
                </Container>
            }
            buttons={[
                {
                    text: t("Cancel"),
                    onClick: onClose,
                    variant: "outline-primary",
                    className: "w-100 fw-normal",
                },
                {
                    text: loading ? <SpinnerLoader variant="light" loadingText={t("Loading...")} /> : t("Unpublish"),
                    onClick: onConfirm,
                    variant: "primary",
                    className: "w-100 fw-bold",
                    disabled: loading,
                },
            ]}
        />
    );
};

export default ConfirmUnpublishMenuModal;
